import {FC} from 'react'
import {Modal} from 'react-bootstrap'
import {TERMS_WEBSITE_URL} from '../core/termsAccess'
import {TermsReader} from './TermsReader'

/**
 * The terms for reading at any time, in a window: the version in force (or an earlier one), what
 * changed, and for a signed-in user of a business, whether and when that business accepted it.
 */
export const TermsViewerModal: FC<{onClose: () => void}> = ({onClose}) => (
  <Modal
    show
    onHide={onClose}
    centered
    size='lg'
    fullscreen='sm-down'
    scrollable
    dialogClassName='mp-terms-dialog'
    aria-labelledby='mp-terms-view-title'
  >
    <Modal.Header closeButton closeLabel='بستن' className='mp-terms-dialog__header'>
      <span className='mp-terms-dialog__icon' aria-hidden='true'>
        <i className='las la-file-contract' />
      </span>
      <Modal.Title as='h2' id='mp-terms-view-title'>
        قوانین و مقررات
      </Modal.Title>
    </Modal.Header>

    <Modal.Body className='mp-terms-dialog__body'>
      <TermsReader />
    </Modal.Body>

    <Modal.Footer>
      <a
        href={TERMS_WEBSITE_URL}
        target='_blank'
        rel='noopener noreferrer'
        className='btn btn-light'
      >
        <i className='las la-external-link-alt fs-4 me-1' aria-hidden='true' />
        مشاهده در وب‌سایت
        <span className='visually-hidden'> (در زبانه جدید)</span>
      </a>
      <button type='button' className='btn btn-primary' onClick={onClose}>
        بستن
      </button>
    </Modal.Footer>
  </Modal>
)
